import * as yup from 'yup'

export const getSchema = (min: number, max: number, maxDecimals: number) =>
  yup
    .object()
    .shape({
      amount: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(min)
        .max(max)
        .test(
          'maxDecimals',
          `Amount can have maximum of ${maxDecimals} decimals`,
          (number) => {
            const decimalsStr = number?.toString()?.split('.')[1]
            return decimalsStr ? decimalsStr.length <= maxDecimals : true
          }
        )
        .nullable()
        .required(),
    })
    .required()
